import React, { useState } from "react";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import { logout } from "../../../redux/actions/authActions";
import { useDispatch } from "react-redux";

const Preferences = () => {
  const [notifications, setNotifications] = useState(true);
  const [emailRecommendation, setEmailRecommendation] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [systemDefault, setSystemDefault] = useState(false);

  const dispatch = useDispatch();

  const handleLogout = () => {
     dispatch(logout());
  };

  const handleDeleteAccount = () => {
    alert("Your account has been deleted.");
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      {/* Language and Time Zone */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <Input label="Language" value="English" />
        <Input
          label="Time Zone"
          value="(GMT-12:00) International Date Line West"
        />
      </div>

      <p className="block text-sm font-medium text-gray-700 mb-4">
        Account Settings
      </p>
      <div className="grid grid-cols-2 gap-4 mb-6">
        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="bg-white  p-3 shadow-sm flex items-center justify-between transition hover:shadow-md"
        >
          <span className="text-sm font-medium text-gray-700">Logout</span>
        </button>

        {/* Delete Account Button */}
        <button
          onClick={handleDeleteAccount}
          className="bg-white p-3 shadow-sm flex items-center justify-between transition hover:shadow-md"
        >
          <span className="text-sm font-medium text-gray-700">
            Delete Account
          </span>
        </button>
      </div>

      {/* Notification Section */}
      <div className="grid grid-cols-2 gap-6">
        <div className="px-2">
          <div className="flex items-center mb-4 justify-between">
            <p className="text-sm font-medium text-gray-700 mr-4">
              Allow Notifications
            </p>
            <div
              className={`relative inline-flex items-center h-6 rounded-full w-12 cursor-pointer mr-2 ${
                notifications ? "bg-green-500" : "bg-gray-300"
              }`}
              onClick={() => setNotifications(!notifications)}
            >
              <span
                className={`${
                  notifications ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full transition`}
              />
            </div>
          </div>
          <div className="flex items-center justify-between mr-2">
            <p className="text-sm font-medium text-gray-700 mr-4">
              Send Email for Recommendation
            </p>
            <div
              className={`relative inline-flex items-center h-6 rounded-full w-12 cursor-pointer ${
                emailRecommendation ? "bg-green-500" : "bg-gray-300"
              }`}
              onClick={() => setEmailRecommendation(!emailRecommendation)}
            >
              <span
                className={`${
                  emailRecommendation ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full transition`}
              />
            </div>
          </div>
        </div>

        {/* Theme Section */}
        <div className="px-2">
          <div className="flex items-center mb-4 justify-between mr-2 ">
            <p className="text-sm font-medium text-gray-700 mr-4">Dark Theme</p>
            <div
              className={`relative inline-flex items-center h-6 rounded-full w-12 cursor-pointer ${
                darkMode ? "bg-green-500" : "bg-gray-300"
              }`}
              onClick={() => setDarkMode(!darkMode)}
            >
              <span
                className={`${
                  darkMode ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full transition`}
              />
            </div>
          </div>
          <div className="flex items-center justify-between mr-2">
            <p className="text-sm font-medium text-gray-700 mr-4">
              System Default
            </p>
            <div
              className={`relative inline-flex items-center h-6 rounded-full w-12 cursor-pointer ${
                systemDefault ? "bg-green-500" : "bg-gray-300"
              }`}
              onClick={() => setSystemDefault(!systemDefault)}
            >
              <span
                className={`${
                  systemDefault ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full transition`}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="mt-6 flex justify-end">
        <Button label="Save" color="primary" />
      </div>
    </div>
  );
};

export default Preferences;
